import {
  Button,
  Group,
  InputWrapper,
  TextInput,
  Stack,
  Blockquote,
} from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import {
  IconArrowLeft,
  IconArrowRight,
  IconInfoCircle,
} from "@tabler/icons-react"
import React from "react"

import { GCSDatasouceCreationFormData } from "@costory/types/endpoints/metricsDatasources"

import { useUser } from "@costory/front/components/auth/UserContext"
import { runtimeConfig } from "@costory/front/lib/runtimeConfig"

type NavigationProps = {
  form: UseFormReturnType<GCSDatasouceCreationFormData>
  handleClickBack: () => void
  handleClickNext: () => void
}

const GCSConfiguration = ({
  form,
  handleClickBack,
  handleClickNext,
}: NavigationProps) => {
  const DEFAULT_SEARCH_PATTERN = "^([^/]+)/"

  const handlePatternChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    form.setFieldValue("tagSearchPattern", value)
  }

  const validateAndNext = () => {
    if (!form.values.tagSearchPattern) {
      form.setFieldValue("tagSearchPattern", DEFAULT_SEARCH_PATTERN)
    }
    form.validate()
    if (form.isValid()) handleClickNext()
  }

  const user = useUser()
  const dataProjectId = runtimeConfig.VITE_DATA_PROJECT_ID

  return (
    <Stack h="100%">
      <Stack flex={1}>
        <Blockquote color="blue" icon={<IconInfoCircle />} mt="xl">
          Share your GCS inventory bucket with costory-
          {user.currentOrg.slug}@{dataProjectId}.iam.gserviceaccount.com:
        </Blockquote>
        <InputWrapper label="Inventory File Path" required>
          <TextInput
            {...form.getInputProps("inventoryFilePath")}
            placeholder="gs://bucket_name/path/to/data"
          />
        </InputWrapper>
        <InputWrapper label="Bucket Name" required>
          <TextInput
            {...form.getInputProps("bucketName")}
            placeholder="my-gcs-bucket-name"
          />
        </InputWrapper>
        <InputWrapper label="Search pattern" required>
          <TextInput
            {...form.getInputProps("tagSearchPattern")}
            placeholder={DEFAULT_SEARCH_PATTERN}
            defaultValue={DEFAULT_SEARCH_PATTERN}
            onChange={handlePatternChange}
          />
        </InputWrapper>
      </Stack>

      <Group justify="space-between" pb={20}>
        <Button
          onClick={handleClickBack}
          variant="outline"
          leftSection={<IconArrowLeft />}
        >
          Back
        </Button>

        <Button onClick={validateAndNext} rightSection={<IconArrowRight />}>
          Next
        </Button>
      </Group>
    </Stack>
  )
}

export default GCSConfiguration
